module.exports = __webpack_public_path__ + "homeaway-fav-icon.png?c72d875c1d234dfb5dcf6701b344a3b0";